import { Button, DrawerFooter, LoadingButton, } from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import React from 'react';
import '../../../styles/drawer.scss';
import { TrackEditDeliveryAddressAnalytics } from '../../../utils/edit-delivery-address/analytics';
import { useOrderContext } from '../../../hooks/useContexts';
export var EditDeliveryAddressChangeFormFooter = function (_a) {
    var isLoading = _a.isLoading, isValidated = _a.isValidated, isIosMobile = _a.isIosMobile, handleValidateDeliveryAddress = _a.handleValidateDeliveryAddress, closeDrawer = _a.closeDrawer, isAddressList = _a.isAddressList, setIsAddNewAddressFlow = _a.setIsAddNewAddressFlow, isSkeletonLoading = _a.isSkeletonLoading;
    var selectedAddressId = useOrderContext().selectedAddressId;
    var getContinueButtonText = function () {
        if (isAddressList) {
            return 'Continue';
        }
        return isValidated ? 'Continue' : 'Confirm This Address';
    };
    return (React.createElement(DrawerFooter, { className: "sui-bg-primary sui-p-4 sui-relative sui-bottom-0 sui-sticky sui-shadow-sm" },
        React.createElement("div", { className: "sui-flex sui-flex-col sui-min-w-full sui-gap-2" },
            React.createElement("div", null,
                React.createElement(LoadingButton, { style: { width: '100%' }, disabled: isSkeletonLoading ||
                        (selectedAddressId && isAddressList
                            ? selectedAddressId === 'current'
                            : false), loading: isLoading, onClick: function () {
                        handleValidateDeliveryAddress();
                        if (isAddressList) {
                            setIsAddNewAddressFlow(false);
                            TrackEditDeliveryAddressAnalytics('purchase history: order details: choose this address button', 'button submission');
                        }
                    } }, getContinueButtonText())),
            React.createElement("div", { className: classNames('card-fix', {
                    'ios-bottom-fix': isIosMobile,
                }) },
                React.createElement(Button, { variant: "secondary", style: { width: '100%' }, onClick: function () { return closeDrawer(); } }, "Cancel")))));
};
